module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/crediga-carburacion/detalles/components/gascom/carburacion-gascom.component.scss
// module id = ./src/app/creditos/crediga-carburacion/detalles/components/gascom/carburacion-gascom.component.scss
// module chunks = main